import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./rootReducer";
import { usersAPI } from '../../features/users/pages/shared/api'
import { saberApi } from '../../features/saber/saberApi'
import { conductorApi } from '../../features/conductor/conductorApi'

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(usersAPI.middleware, saberApi.middleware, conductorApi.middleware),
  devTools: import.meta.env.dev as boolean,
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppDispatch = typeof store.dispatch;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type RootState = ReturnType<typeof store.getState>;
